import { html, nothing } from 'lit';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import componentStyles from './hp-prefooter.css.lit.ts';
import { OutlineElement } from '../../base/outline-element/outline-element.ts';

export default class PreFooter extends OutlineElement {
  static styles = [super.styles, componentStyles];

  constructor() {
    super();
  }

  render() {
    return html`
      <div class="prefooter-wrapper">
        <div class="prefooter">
          <div class="prefooter--column prefooter--column-1">
            <slot name="column_one"></slot>
          </div>
          <div class="prefooter--column prefooter--column-2">
            <slot name="column_two"></slot>
          </div>
        </div>
      </div>
    `;
  }
}

customElements.define('hf-hp-prefooter', PreFooter);

